import * as React from 'react';
import InputText from '../../../../../common/components/InputText';
import {LOAN_APPLICATION_MX, ERROR} from '../../../../constants/LabelConstants';
import Button from '../../../../../common/components/Button';
import * as ValidateConstant from '../../../../constants/ValidateConstant';
import {INPUTS} from '../../../../constants/MX/WizardInputs';
import * as InputTextTypes from '../../../../../common/components/InputTextTypes';
import {
    ValidateNIPPrivacyBureauProps,
    ValidateNIPPrivacyBureauState
} from '../../../../types/mx/farrera/components';

class ValidateNIPBureauView extends React.Component<ValidateNIPPrivacyBureauProps, ValidateNIPPrivacyBureauState> {
    constructor(props) {
        super(props);
        this.state = {
            counter: this.props.counter,
            nip: this.props.nip ? null : ValidateConstant.ERROR_REQUIRED_NIP,
            showErrors: false,
            disabledValidateButton: true
        };
        this.startCounter();
    }

    startCounter = () => {
        // @ts-ignore Todo @nino corregir este problema con typescripts
        this.counterInterval = setInterval(() => {
            if (this.state.counter === 0) {
                this.stopCounter();
            } else {
                this.setState({
                    counter: this.state.counter - 1
                });
            }
        }, 1000);
    }

    stopCounter = () => {
        // @ts-ignore Todo @nino corregir este problema con typescripts
        clearInterval(this.counterInterval);
    }

    transformCounter = (counter) => {
        const minutes = Math.floor((counter % (1000 * 60 * 60)) / (60));
        const distance = counter - (minutes * 60);
        const seconds = Math.floor((distance % (1000 * 60)));
        const secondsAsString = (seconds < 10 ? '0' : '') + seconds;
        return `${minutes}:${secondsAsString}`;
    }

    processNipErrors = (nip, hasNipValidationError) => {
        if (hasNipValidationError) {
            return ERROR.INVALID_NIP_CODE_ERROR;
        }
        return nip ? null : ValidateConstant.ERROR_REQUIRED;
    }

    componentDidUpdate(prevProps, prevState) {
        const error = this.processNipErrors(this.props.nip, this.props.hasNipValidationError);
        const errorPrev = this.processNipErrors(prevProps.nip, prevProps.hasNipValidationError);
        if (error !== errorPrev) {
            this.setState({ nip: error, showErrors: !!error });
        }
    }

    onPressResendNIP = () => {
        this.props.onPressResendNIP();
        this.setState({
            counter: this.props.counter
        });
        this.startCounter();
    }

    renderSendNipAgainContainer = () => {
        return (
            <div className="mb-5">
                <div className="d-flex justify-content-center mb-2">
                    <Button onPress={this.onPressResendNIP} type="link" customClass="resend-text-modal"
                            text={LOAN_APPLICATION_MX.RESEND_NIP.toUpperCase()}/>
                </div>
                <div className="d-flex justify-content-center">
                    <Button onPress={this.props.onPressEditApplicantDataForNIP} type="link"
                            customClass="resend-text-modal"
                            text={LOAN_APPLICATION_MX.EDIT_FOR_NIP.toUpperCase()}/>
                </div>
            </div>
        );
    }

    renderCounterContainer = () => {
        return (
            <div className="mb-5 resend-text-modal">
                {LOAN_APPLICATION_MX.RESEND_NIP_IN.toUpperCase()} {this.transformCounter(this.state.counter)}
            </div>
        );
    }

    onPressNext = () => {
        if (this.validateFields()) {
            return this.props.onPressNext();
        }
        this.setState({showErrors: true});
    }

    validateFields = () => this.state.nip === null;

    onChangeNIP = (value, error, inputId) => {
        this.setState({nip: error, disabledValidateButton: value.length < (ValidateConstant.NIP_CHARACTERS - 1)});
        this.props.onChangeNIP(value, error, inputId);
    }

    render() {

        const {name, email, phone, nip} = this.props;
        const renderNipContainer = this.state.counter === 0 ? this.renderSendNipAgainContainer() :
            this.renderCounterContainer();
        const nipQueryMessage = LOAN_APPLICATION_MX.NIP_QUERY_MESSAGE
            .replace('$name', name)
            .replace('$email', `<b>${email}</b>`)
            .replace('$phone', `<b>${phone}</b>`);

        return (
            <React.Fragment>
                <div className="modal-info">
                    <div className="modal-scroll">
                        <div>

                            <div className="row">
                                <div className="col-sm-12 p-none">
                                    <div className="avatar-text flex-middle width-100">
                                        <div className="img">
                                            <div className="avatar">

                                            </div>
                                        </div>
                                        <div className="text">
                                            <div className="content-area line-height-small">
                                                <span className="size-h6 text-secondary text-lighten-2 medium">

                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12 p-none mb-3">
                                    <div className="mb-2" dangerouslySetInnerHTML={{__html: nipQueryMessage}}/>
                                    <div className="mb-2">
                                        {LOAN_APPLICATION_MX.NIP_VALIDATION_LEGAL_MSG}
                                    </div>
                                </div>
                            </div>

                            <div className="row d-flex justify-content-center mb-3">
                                <div className="col">
                                    <InputText id={INPUTS.NIP}
                                               label={LOAN_APPLICATION_MX.NIP_IDENTITY}
                                               value={nip}
                                               required={true}
                                               maxLength={ValidateConstant.NIP_CHARACTERS}
                                               minLength={ValidateConstant.NIP_CHARACTERS - 1}
                                               hasError={this.state.showErrors}
                                               labelError={this.state.nip}
                                               onChange={this.onChangeNIP}
                                               type={InputTextTypes.PASSWORD}
                                               inputCustomClass="input-modal"
                                               align={'center'}/>
                                </div>
                            </div>

                            <div className="row d-flex justify-content-center border-bottom">
                                {renderNipContainer}
                            </div>

                            <div className="row mt-4">
                                <div className="col-12 d-flex justify-content-center">
                                    <Button text={LOAN_APPLICATION_MX.VALIDATE_NIP} onPress={() => this.onPressNext()}
                                            role="button"
                                            disabled={this.state.disabledValidateButton}
                                            customClass="px-md-5"/>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default ValidateNIPBureauView;
